import React from 'react';
import ReactDOM from 'react-dom';

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
//import { ProfileThumb } from '@shyft/acorns';

import { commentFormat, messageDateFormat, } from 'helpers/date-time';
import styled from './styled';
import './Post.scss';
import { extractChatParticipant } from 'helpers/community-util';
import { getUserName, getUserId, getUserProfileImage } from '../../../../../helpers/cookies';
import Modal from 'components/GeneralComponents/Modal';
import ImageWin from 'pages/CommunityMergeFeed/TeamFeed/blocks/Post/ImageWin';

const sha1 = require('js-sha1');

const isAnnouncement = (post_type) => {
  return [1, 2, 3, 4].includes(post_type);
};


class ChatMessage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      debug: false,
      hovered: false,
      enlarged: false,
      showPictureView: false,
      selectedPicture: '',
      allPictures: [],
      modalWindow: null,
      show: false,
      currentIdx: -1,
      currentTarget: null,
      theUser: null,
      likeList: [],
      readList: [],
      mouseOverCount: false,
      mouseTipPos: null,
      likeIconPos: null,
      selectedImageUrl: null,
    };
    this.messageWrapRef = React.createRef();
    this.attachedImageRef = React.createRef();
    this.imageContainerRef = React.createRef();
    this.nwRef = React.createRef();
    this.countRef = React.createRef();
    this.readCountRef = React.createRef();
    this.handleTitleClick = this.handleTitleClick.bind(this);
    this.handleClickLink = this.handleClickLink.bind(this);

    this.selectedUrl = '';
    this.metaUrl = '';
    this.prevHeight = 0;

  }

  componentDidMount() {
    const { data, allUsers, onlineUsers, fetchPostLikeList, fetchPostReaderList, } = this.props;
    const { theUser, } = this.state;
    const { attachment } = data;
    if (attachment) {
      this.setState({ allPictures: attachment.object_instances });
    }
    if (data && allUsers) {
      const users = allUsers.filter((user) => user.owner_id === data.owner_id);
      if (users && users.length > 0) {
        this.setState({ theUser: users[0] });
      }
    }

    window.addEventListener("mousemove", this.logMousePosition);
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate(prevProps, prevState) {
    const { data, allUsers, onlineUsers, notifyPostLikedChanged, receipts, } = this.props;
    const { theUser, readList, } = this.state;

    if (prevProps.data !== data) {
      if (data && allUsers) {
        const users = allUsers.filter((user) => user.owner_id === data.owner_id);
        if (users && users.length > 0) {
          this.setState({ theUser: users[0] });
        }
      }
      if (data.liked !== prevProps.data.liked) {
        if (notifyPostLikedChanged) {
          notifyPostLikedChanged(data.id, data.liked);
        }
      }

      if (data.likeList) {
        if (data.likeList.length > 0) {
          let likers = [];
          if (allUsers) {
            for (let i = 0; i < data.likeList.length; i++) {
              const liker = allUsers.filter((person) => person.owner_id === data.likeList[i]);
              if (liker && liker.length > 0) {
                likers.push(liker[0]);
              }
            }
          }
          this.setState({ likeList: likers });
        }
      }
      if (data.readList) {
        if (data.readList.length > 0) {
          let readers = [];
          if (allUsers) {
            for (let j = 0; j < data.readList.length; j++) {
              const reader = allUsers.filter((person) => person.owner_id === data.readList[j]);
              if (reader && reader.length > 0) {
                readers.push(reader[0]);
              }
            }
          }
          this.setState({ readList: readers });
        }
      }

      if (data.attachment) {
        this.setState({ allPictures: data.attachment.object_instances });
      }
    }

    if (prevProps.allUsers !== allUsers) {
      if (allUsers && allUsers.length > 0) {
        if (data) {
          const users = allUsers.filter((user) => user.owner_id === data.owner_id);
          if (users && users.length > 0) {
            this.setState({ theUser: users[0] });
          }
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.state.modalWindow && !this.state.modalWindow.closed) {
      this.state.modalWindow.close();
    }
    window.removeEventListener("mousemove", this.logMousePosition);
    document.removeEventListener('keydown', this.handleKeyDown);

  }

  getUserUUID = (userId) => {
    return `user.${sha1(`user.${userId}`)}`;
  };

  logMousePosition = (e) => {
    const { likeIconPos, } = this.state;
    if (likeIconPos) {
      if (e.clientX < likeIconPos.x && e.clientY > likeIconPos.y) {
        this.setState({ mouseOverCount: false });
      } else if (e.clientX > likeIconPos.x + likeIconPos.width && e.clientY > likeIconPos.y) {
        this.setState({ mouseOverCount: false });
      } else if (e.clientY > likeIconPos.y + likeIconPos.height) {
        this.setState({ mouseOverCount: false });
      }
    }
  }

  handleMouseEnter = () => {
    this.setState({ hovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ hovered: false });
  };

  handleImageClick = (url) => {
    this.setState({ selectedImageUrl: url });
  };

  closeImagePreview = () => {
    this.setState({ selectedImageUrl: null });
  };

  handleTitleClick = (event) => {
    window.open(this.metaUrl);
    event.preventDefault();
  };

  handleClickLink = (event) => {
    window.open(this.metaUrl);
    event.preventDefault();
  };

  handleUrlClick = (event) => {
    window.open(event.target);
    event.preventDefault();
  }

  containUrl(text) {
    if (typeof text !== 'string' || text.length < 5) return false;
  
    const urlRegex = /\b((https?:\/\/)?(www\.)?[\w-]+\.[a-z]{2,}(\/\S*)?)/i;
    return urlRegex.test(text);
  }

  extractUrl(text) {
    const urlRegex = /\b((https?:\/\/)?(www\.)?[\w-]+\.[a-z]{2,}(\/\S*)?)/i;
  
    if (typeof text !== 'string' || text.length < 5) return null;
  
    const match = text.match(urlRegex);
    if (!match || !match[1]) return null;
  
    let url = match[1];
  
    // Remove trailing comma or period from URL
    const lastChar = url.slice(-1);
    if (lastChar === ',' || lastChar === '.') {
      url = url.slice(0, -1);
    }
  
    const start = text.indexOf(url);
    const beforeUrl = start > 0 ? text.substring(0, start) : '';
    const afterUrl = text.substring(start + url.length);
  
    return (
      <span>
        {beforeUrl}
        <a href={url.startsWith('http') ? url : `https://${url}`} onClick={this.handleUrlClick}>
          {url}
        </a>
        {afterUrl}
      </span>
    );
  }


  handleSubmit = (event) => {

  };

  findSelected = (picTofind) => {
    const { allPictures } = this.state;

    for (var i = 0; i < allPictures.length; i++) {
      if (allPictures[i].thumb_url === picTofind ||
        allPictures[i].gallery_url === picTofind ||
        allPictures[i].original_url === picTofind ||
        allPictures[i].full_url === picTofind) {
        return i;
      }
    }
    return -1
  }

  closeModalWindow = () => {
    if (this.state.modalWindow) {
      this.state.modalWindow.close();
    }

    this.setState({ show: false });
  }

  renderPDF = (pdfObjects) => {

    return pdfObjects.map((pdf, index) => {
      const sizeText = `${Math.round(pdf.byte_size / 1000)} KB`;
      return (
        <styled.PDFWrap
          key={pdf.id}
          onClick={() => {
            console.log(pdf.blob_url);
            window.open(pdf.service_url);
          }}>
          <styled.PDFIcon
            src='/icons/pdf-icon.svg'>
          </styled.PDFIcon>
          <styled.PDFProps>
            <styled.PDFName>{pdf.filename}</styled.PDFName>
            <styled.PDFSizeWrap>
              <styled.PDFSize>PDF</styled.PDFSize>
              <styled.Circle />
              <styled.PDFSize>{sizeText}</styled.PDFSize>
            </styled.PDFSizeWrap>
          </styled.PDFProps>
        </styled.PDFWrap>
      );
    });
  };

  mouseEnterCount = (event) => {
    let winTop = '';
    let winLeft = '';
    let output = null;
    const winW = '160px';//`50%`;
    const winH = `60px`; //94.9% viewport height
    if (this.countRef && this.countRef.current) {
      const domNode = ReactDOM.findDOMNode(this.countRef.current);
      output = domNode.getBoundingClientRect();
      if (output) {
        winTop = `${output.y - output.height - 30}px`;
        winLeft = `${output.x - 78}px`;
      }
    }
    const winData = {
      top: winTop,
      left: winLeft,
      width: winW,
      height: winH,
    }
    this.setState({ mouseTipPos: winData, likeIconPos: output, mouseOverCount: true });
  }

  mouseLeaveCount = (event) => {
    //this.setState({mouseOverCount: false});
  }

  HandleMouseEnterTip = (event) => {

  }

  HandleMouseLeaveTip = (event) => {
    this.setState({ mouseOverCount: false });
  }

  extractImageURL(text) {
    return text.replace("[IMG]", "").replace("[/IMG]", "");
  }

  HandleOthersClicked = (event) => {
    const { setActiveSidePane, setActivePost, data, activeChannel, } = this.props;

    this.setState({ mouseOverCount: false });
    if (!isAnnouncement(data.post_type)) {
      if (setActiveSidePane) {
        setActiveSidePane('likers');
      }
      if (setActivePost && data && activeChannel) {
        setActivePost(data.id, activeChannel.channel_name);
      }
    } else {
      if (setActiveSidePane) {
        setActiveSidePane('read-receipts');
      }
      if (setActivePost && data && activeChannel) {
        setActivePost(data.id, activeChannel.channel_name);
      }
    }
  }

  renderCountMouseTip = (isAnnouncement) => {
    const { mouseTipPos, likeList, readList, } = this.state;

    const mouseTipStyle = {
      top: mouseTipPos.top,
      left: mouseTipPos.left,
      minWidth: mouseTipPos.width,
      height: mouseTipPos.height,
      position: 'absolute',
      backgroundColor: 'black',
      color: 'white',
      boxShadow: '0 5px 10px 2px rgba(195,192,192,.5)',
      zIndex: 2,
      //overflow: 'scroll',
      borderRadius: '5px',
      paddingTop: '10px',
      display: 'flex',
      flexDirection: 'row',
      //border: '1px solid red',
    };

    const checkMarkStyle = {
      width: '18px',
      height: '18px',
      marginLeft: '12px',
      marginTop: '12px',
      //marginRight: '0px',
    };

    const messageWrapStyle = {
      paddingLeft: 0,
      //border: '1px solid red',
    };

    let displayText = '';
    let user1 = '';
    let user2 = '';
    let reader1 = '';
    let reader2 = '';
    let numOthers = 0;

    if (!isAnnouncement) {
      if (likeList && likeList.length > 0) {
        if (likeList.length === 1) {
          user1 = `${likeList[0].first_name} ${likeList[0].last_name}`;
        } else if (likeList.length >= 2) {
          user1 = `${likeList[0].first_name} ${likeList[0].last_name}`;
          user2 = `${likeList[1].first_name} ${likeList[1].last_name}`;
        }
      }
      numOthers = likeList && likeList.length > 2 ? likeList.length - 2 : 0;
    } else {
      if (readList && readList.length > 0) {
        if (readList.length === 1) {
          reader1 = `${readList[0].first_name} ${readList[0].last_name}`;
        } else if (readList.length >= 2) {
          reader1 = `${readList[0].first_name} ${readList[0].last_name}`;
          reader2 = `${readList[1].first_name} ${readList[1].last_name}`;
        }
      }
      numOthers = readList && readList.length > 2 ? readList.length - 2 : 0;
    }

    const and = (<FormattedMessage
      id="Post.and"
      defaultMessage="and"
    />);
    const likedBy = (<FormattedMessage
      id="Post.likedBy"
      defaultMessage="Liked by {user1}"
      values={{ user1, }}
    />);
    const likedBy2 = (<FormattedMessage
      id="Post.likedBy2"
      defaultMessage="Liked by {user1}, {user2}"
      values={{ user1, user2, }}
    />);
    const likedByMore = (<FormattedMessage
      id="Post.likedByMore"
      defaultMessage="{numOthers} others"
      values={{ numOthers }}
    />);
    const readBy = (<FormattedMessage
      id="Post.readBy"
      defaultMessage="Read by {reader1}"
      values={{ reader1, }}
    />);
    const readBy2 = (<FormattedMessage
      id="Post.readBy2"
      defaultMessage="Read by {reader1}, {reader2}"
      values={{ reader1, reader2, }}
    />);
    const readByMore = (<FormattedMessage
      id="Post.readByMore"
      defaultMessage="{numOthers} others"
      values={{ numOthers }}
    />);

    if (isAnnouncement) {
      if (readList && readList.length > 0) {
        if (readList.length === 1) {
          displayText = readBy;
        } else if (readList.length >= 2) {
          displayText = readBy2;
        }
      }
    } else {
      if (likeList && likeList.length > 0) {
        if (likeList.length === 1) {
          displayText = likedBy;
        } else if (likeList.length >= 2) {
          displayText = likedBy2;
        }
      }
    }

    if (isAnnouncement) {
      return (
        <div style={mouseTipStyle} onMouseEnter={this.HandleMouseEnterTip} onMouseLeave={this.HandleMouseLeaveTip}>
          <img src='/icons/mark-green.png' style={checkMarkStyle} />
          <div style={messageWrapStyle}>
            <div className="count-mouse-tip__top-wrap">{displayText}</div>
            {(readList && readList.length > 2) &&
              <div className="count-mouse-tip__wrap">{and}
                <div className="count-mouse-tip__others" onClick={this.HandleOthersClicked}>{isAnnouncement ? readByMore : likedByMore}</div>
              </div>}
          </div>
        </div>
      );
    } else {
      return (
        <div style={mouseTipStyle} onMouseEnter={this.HandleMouseEnterTip} onMouseLeave={this.HandleMouseLeaveTip}>
          <img src='/icons/like-icon.svg' style={checkMarkStyle} />
          <div style={messageWrapStyle}>
            <div className="count-mouse-tip__top-wrap">{displayText}</div>
            {(likeList && likeList.length > 2) &&
              <div className="count-mouse-tip__wrap">{and}
                <div className="count-mouse-tip__others" onClick={this.HandleOthersClicked}>{isAnnouncement ? readByMore : likedByMore}</div>
              </div>}
          </div>
        </div>
      );
    }
  }

  handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      this.closeImagePreview();
    }
  };

  render() {
    const {
      active,
      data,
      clickComment,
      clickDelete,
      clickLike,
      clickPin,
      className,
      clickReadReceipts,
      clickCopy,
      clickMoreActions,
      allUsers,
      onlineUsers,
      index,
      activeChat,
    } = this.props;
    const { hovered, enlarged, theUser, debug, mouseOverCount, } = this.state;
    const {
      attachment,
      message,
      id,
      message_type,
      created_at,
      final_allow_comment,
      final_allow_delete,
      final_allow_like,
      sender_id,
      session_id,
      attached_files_blobs,
    } = data;


    let urlInContent = this.extractUrl(message);
    if (!urlInContent) {
      urlInContent = message;
    }

    const participant = extractChatParticipant(activeChat);
    const sessionUser = participant ? participant.owner : null;
    const sessionUserName = sessionUser ? `${sessionUser.first_name} ${sessionUser.last_name}` : '';

    const loggedInUserId = getUserId();
    const loggedInUserName = getUserName();
    const loggedInUserProfileImage = JSON.parse(getUserProfileImage());

    let sizeText = '';
    if (attached_files_blobs && attached_files_blobs.length > 0) {
      sizeText = `${Math.round(attached_files_blobs[0].byte_size / 1000)} KB`;
    }

    let senderProfileUrl = '/icons/default-profile-thumb.svg';
    let senderUserName = '';

    if (String(sender_id) === loggedInUserId) {

      if (loggedInUserProfileImage && loggedInUserProfileImage.thumb_url) {
        senderProfileUrl = loggedInUserProfileImage.thumb_url;
      }
      senderUserName = loggedInUserName;
    } else if (sessionUser && sender_id === sessionUser.id) {
      if (sessionUser && sessionUser.thumb_url) {
        senderProfileUrl = sessionUser.thumb_url;
      }
      senderUserName = sessionUserName;
    }

    const isImageTypeChatMessage = message_type === "message_image";

    const showAdminBadge = theUser && theUser.is_admin ? true : false;
    const approvedBadge = '/icons/verified-badge-icon.svg';
    const announcementIcon = '/icons/announcement-icon.svg';
    const pinnedIcon = '/icons/pinned-post-icon.svg';
    const userUUID = theUser ? this.getUserUUID(theUser.owner_id) : this.getUserUUID(data.owner_id);

    let showOnline = false;
    if (onlineUsers && onlineUsers.includes(userUUID)) {
      showOnline = true;
    }
    let showReadCount = false;
    let readCount = 0;
    if (data.readList && data.readList.length > 0) {
      showReadCount = true;
      readCount = data.readList.length;
    }

    const announceText = (<FormattedMessage
      id="Post.announcement"
      defaultMessage="Announcement"
    />);

    const pinnedText = (<FormattedMessage
      id="Post.pinned"
      defaultMessage="Pinned"
    />);

    return (
      <styled.MessageWrap
        className={className}
        modifiers={active ? 'active' : null}
        announcement={false}
        pinned={false}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={() => {
          void 0;
        }}
        ref={this.messageWrapRef}
      >
        <styled.AvatarAndInfoWrap>
          {debug && <p>{data.id}</p>}
          <styled.AvatarWrap>
            <styled.ProfileAvatar src={senderProfileUrl} />
            {showOnline && <styled.OnlineMark />}
          </styled.AvatarWrap>
          <styled.InfoWrap>
            <styled.Name>
              {senderUserName}
              {showAdminBadge && <styled.ApprovedBadge src={approvedBadge} />}
              {/*isAnnouncement(post_type) && (
              <Icon path={mdiBullhorn} size={1} color="#acacac" />
            )*/}
            </styled.Name>
            <styled.Timestamp>{messageDateFormat(created_at)}</styled.Timestamp>

            {isImageTypeChatMessage ? <styled.ImageGroupWrap>
              <styled.Image
                src={this.extractImageURL(message)}
                onClick={() => this.handleImageClick(this.extractImageURL(message))}
              />
            </styled.ImageGroupWrap> : <styled.Content>{urlInContent}</styled.Content>}

            {/* {(hovered && post_type > 0) &&
              <Buttons
                active={active}
                data={data}
                clickComment={clickComment}
                clickDelete={clickDelete}
                clickLike={clickLike}
                clickPin={clickPin}
                clickCopy={clickCopy}
                clickReadReceipts={clickReadReceipts}
                //clickMoreActions={clickMoreActions}
                pinned={pinned}
                liked={liked}
                index={index}
                activeChannel={activeChannel}
              />
            } */}

          </styled.InfoWrap>
        </styled.AvatarAndInfoWrap>
        {this.state.selectedImageUrl && (
          // <styled.ImageOverlay onClick={this.closeImagePreview}>
          //   <styled.EnlargedImage
          //     src={this.state.selectedImageUrl}
          //     onClick={(e) => e.stopPropagation()} // prevent closing on image click
          //   />
          // </styled.ImageOverlay>

          <Modal>
            <ImageWin selected={this.state.selectedImageUrl}
              allPictures={[this.state.selectedImageUrl]}
              enlarged={false}
              isChat={true}
              currentIdx={0}
              closeWin={this.closeImagePreview}
            />
          </Modal>
        )}
      </styled.MessageWrap >
    );
  }
}

ChatMessage.propTypes = {
  clickDelete: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

ChatMessage.defaultProps = {
  className: '',
};

export default ChatMessage;
